
import { getGlobalObject } from '@sentry/utils';

const global = getGlobalObject<Window>();

const inApplication = (ua: string): boolean => ua.indexOf('DidaPinche') !== -1; // App端内
const isDidaPinche = (ua: string): boolean => inApplication(ua) && ua.indexOf('[App]') > -1; // 出行端
const isDidaTaxi = (ua: string): boolean => inApplication(ua) && ua.indexOf('[App]') === -1; // 司机端
const isIos = (ua: string): boolean => !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios
const isAndroid = (ua: string): boolean => ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1; // android
const inWechat = (ua: string): boolean => /MicroMessenger/g.test(ua); // 微信环境
const isAlipay = (ua: string): boolean => ua.indexOf('Alipay') !== -1; // 支付宝环境
// @ts-ignore
const inWxMiniprogram = (ua: string): boolean => ua.match(/micromessenger/i) && ua.match(/miniprogram/i) || global.__wxjs_environment === 'miniprogram'; // 微信小程序
// @ts-ignore
const inAliMiniprogram = (ua: string): boolean => ua.match(/Alipay/i) && ua.match(/miniprogram/i); // 支付宝小程序


const getClient = (): string => {
  const UA = global.navigator.userAgent;
  let client = '其他';

  if (isDidaPinche(UA)) {
    if (isIos(UA)) {
      client = 'h5_出行端app_IOS';
    } else if (isAndroid(UA)) {
      client = 'h5_出行端app_Android';
    }
  } else if (isDidaTaxi(UA)) {
    if (isIos(UA)) {
      client = 'h5_司机端app_IOS';
    } else if (isAndroid(UA)) {
      client = 'h5_司机端app_Android';
    }
  } else if (inWechat(UA)) {
    client = 'h5_微信浏览器';

    if (inWxMiniprogram(UA)) {
      client = 'h5_微信小程序';
    }
  } else if (isAlipay(UA)) {
    client = 'h5_支付宝';

    if (inAliMiniprogram(UA)) {
      client = 'h5_支付宝小程序';
    }
  } else if (/(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|SymbianOS|ToutiaoMicroApp|AppleWebKit.*Mobile.*)/i.test(UA)) {
    client = 'h5_其他移动端';
  }

  return client;
}

export {
  getClient
}